
import http from "../http";

const apiEndpoint = process.env.REACT_APP_BASE_URL +  "/api/Auth/ResetPassword";

export function ResetPassword(obj) {
  
  return http.post(apiEndpoint, obj);
}
